import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Directive({
  selector: '[opac-go-back]',
})
export class GoBackDirective {

  private initialNavigation = true;

  @HostListener('click')
  onHostClick(): void {
    if (this.defaultLocation.length === 0) {
      this.location.back();
      return;
    }

    if (this.forceNavigate || this.initialNavigation) {
      this.router.navigate(this.defaultLocation);
      return;
    }

    this.location.back();
  }

  @Input('opac-go-back') defaultLocation: string[] = [];
  @Input() forceNavigate = false;

  constructor(
    private readonly location: Location,
    private readonly router: Router,
  ) {
    this.initialNavigation = this.router.getCurrentNavigation()?.previousNavigation === null;
  }
}
